export default "__VITE_ASSET__be8a5c38__"